module.exports = __webpack_public_path__ + "img/post-19.ef8ab516.jpg";